import React from 'react';
import SocialMedia from '../SocialMedia';
import LogoPlaceholder from '../LogoPlaceHolder';
import { Promoter } from '../../types/promoter';

interface FooterProps {
    promoter: Promoter;
    loading: boolean;
}

const Footer = React.forwardRef<HTMLElement, FooterProps>((props, ref) => {
    const { promoter, loading } = props;

    if (loading) return <p></p>;

    return (
        <footer className="footer" ref={ref}>
            <div className="footer__wrapper">
                <div className="footer__column-logo">
                    <ul>
                        <li>
                            {promoter.logoURL && !promoter.logoURL.includes('null') ? <img src={promoter.logoURL} alt={promoter.fullname} className="logo" /> : <LogoPlaceholder name={promoter.fullname} />}
                        </li>
                        <li>
                            <p>(c) {new Date().getFullYear()} Powered by trip Promoter LLC</p>
                        </li>
                    </ul>
                </div>
                <div className='border__footer'></div>
                <div className="footer__column-terms">
                    <ul>
                        <li>
                            <a href="https://trippromoter.com/terminos-y-condiciones/" rel="noreferrer" target="_blank">Términos
                                y
                                Condiciones</a>
                        </li>
                        <li>
                            <a href="https://trippromoter.com/politicas-de-privacidad/" rel="noreferrer"
                                target="_blank">Políticas de
                                Privacidad</a>
                        </li>
                    </ul>
                </div>

                <div className='border__footer'></div>

                <div className="footer__column-contact">
                    <ul>
                        <li>
                            <span>BTCOM LEG N°17779</span>
                        </li>
                        <li>
                            <a href="https://wa.me/5491127516586" target="_blank" rel="noreferrer">+5491127516586</a>
                        </li>
                        <li>
                            <a href="mailto:">ventas@buentour.com</a>
                        </li>
                    </ul>
                </div>

                <div className="footer__column-icons">
                    <p>Follow Us</p>
                    <SocialMedia />
                </div>
            </div>
        </footer>
    );
});

export default Footer;
